export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  featuredImage: string;
  images: string[];
  videos?: string[];
  date: string;
  category: string;
  tags: string[];
}

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    slug: 'nursing-home-furniture-installation-90k-project',
    title: 'How We Furnished a New Nursing Home in Under 8 Hours',
    excerpt: 'Twenty boxed bedroom sets plus every common area, assembled and placed alongside the designer at a new Northeast Wisconsin nursing home in under 8 hours.',
    content: `
A brand-new nursing home in Northeast Wisconsin needed to be furnished. The rooms were finished, but every resident room and common area was empty, and all of the furniture was still in boxes. That's where we came in.

## The job

- **20 complete bedroom sets**, every piece still boxed up
- **Every common area** too, including the dining rooms and a living room with a fireplace
- **A designer** we worked alongside to get every piece in the right spot
- **High-value furniture** on a job worth around $90,000, so there was no room for mistakes

## Unloaded, unboxed and built on site

We unloaded the trucks, carried everything in and got to work. Each bedroom set was unboxed, assembled and set up in its room, and the common areas got their tables, chairs and seating the same way.

We worked with the designer the whole time, so every bed, table and chair ended up exactly where the plan called for it, not just close enough. With brand-new furniture going into a brand-new building, careful handling mattered just as much as speed.

## Done in under 8 hours

From the first box to the last chair, the whole job took less than 8 hours. The photos below show the finished dining rooms and living room, plus a few shots from along the way.

## Have a big install coming up?

We deliver, assemble and place furniture for homes and businesses across Green Bay, the Fox Valley and Door County, from a single piece to a whole building like this one. Designers, furniture stores and property managers can [request a quote](/contact) or call us at (920) 255-8952. You can also see more about our [delivery services](/services/delivery).

Replacing old furniture? We can haul that away too with our [junk removal service](/services/junk-removal).
    `,
    featuredImage: '/assets/images/blog/nursing-home-install-1.jpg',
    images: [
      '/assets/images/blog/nursing-home-install-1.jpg', // Living room with fireplace (finished)
      '/assets/images/blog/nursing-home-install-2.jpg', // Dining room (finished)
      '/assets/images/blog/nursing-home-install-3.jpg', // Dining table close-up (finished)
      '/assets/images/blog/nursing-home-install-4.jpg', // Dining hall mid-assembly
      '/assets/images/blog/nursing-home-install-5.jpg', // Common room mid-setup
      '/assets/images/blog/nursing-home-install-6.jpg', // Boxed bed frames in the hallway
      '/assets/images/blog/nursing-home-install-7.jpg', // Truck full of boxes
      '/assets/images/blog/nursing-home-install-8.jpg', // Wrapped furniture coming off the truck
    ],
    videos: ['/assets/videos/nursing-home-install.mp4'],
    date: '2026-01-30',
    category: 'Commercial Projects',
    tags: ['commercial', 'furniture installation', 'nursing home', 'assembly', 'senior living'],
  },
];

export const getBlogPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};
